/* Offering feature: scroll-snap carousel + optional variant size tabs.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  function init(root) {
    var track = root.querySelector('[data-of-track]');
    var prev = root.querySelector('[data-of-prev]');
    var next = root.querySelector('[data-of-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-of-dot]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-of-tab]'));
    var priceEl = root.querySelector('[data-of-price]');
    var sizeEl = root.querySelector('[data-of-size]');
    var btn = root.querySelector('[data-of-btn]');

    function slideWidth() {
      var slide = track && track.querySelector('.of-slide');
      return slide ? slide.getBoundingClientRect().width : 0;
    }

    function currentIndex() {
      var w = slideWidth();
      if (!w) return 0;
      return Math.round(track.scrollLeft / w);
    }

    function goTo(index) {
      var w = slideWidth();
      if (!w) return;
      var count = track.querySelectorAll('.of-slide').length;
      var clamped = Math.max(0, Math.min(index, count - 1));
      track.scrollTo({ left: clamped * w, behavior: 'smooth' });
    }

    function updateDots() {
      var idx = currentIndex();
      dots.forEach(function (dot, i) {
        var active = i === idx;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    if (track) {
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          updateDots();
        });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
      });
    }

    /* Waitlist result + re-opening the mini tab after a submit:
       assets/sesen-mini-tab.js (shared with the product page). */

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active')) return;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var isMini = tab.dataset.mini === '1';
        root.classList.toggle('of-mini-active', isMini);
        if (priceEl && tab.dataset.price) priceEl.textContent = tab.dataset.price;
        if (sizeEl) sizeEl.textContent = tab.dataset.sizeText || '';
        if (btn && tab.dataset.variantId) {
          var base = btn.dataset.ofBtnBase || btn.getAttribute('href').split('?')[0];
          btn.setAttribute('href', base + '?variant=' + tab.dataset.variantId);
          var available = tab.dataset.available === 'true';
          btn.classList.toggle('is-disabled', !available);
          btn.setAttribute('aria-disabled', available ? 'false' : 'true');
        }
        /* Swap the first slide to the selected variant's image, keep the
           original so switching back restores it. A video slide shows its
           poster image instead while a variant image is active. */
        var firstSlide = track && track.querySelector('.of-slide');
        var firstImg = firstSlide && firstSlide.querySelector('img');
        var firstVideo = firstSlide && firstSlide.querySelector('video');
        if (firstVideo) {
          firstSlide.classList.toggle('of-slide--variant-image', !!tab.dataset.image);
          if (tab.dataset.image && !firstVideo.paused) firstVideo.pause();
        }
        if (firstImg) {
          if (!firstImg.dataset.origSrc) {
            firstImg.dataset.origSrc = firstImg.getAttribute('src') || '';
            firstImg.dataset.origSrcset = firstImg.getAttribute('srcset') || '';
            firstImg.dataset.origAlt = firstImg.getAttribute('alt') || '';
          }
          if (tab.dataset.image) {
            firstImg.removeAttribute('srcset');
            firstImg.setAttribute('src', tab.dataset.image);
            if (tab.dataset.alt) firstImg.setAttribute('alt', tab.dataset.alt);
          } else {
            firstImg.setAttribute('src', firstImg.dataset.origSrc);
            if (firstImg.dataset.origSrcset) firstImg.setAttribute('srcset', firstImg.dataset.origSrcset);
            firstImg.setAttribute('alt', firstImg.dataset.origAlt);
          }
          goTo(0);
        }
      });
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-offering-feature]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.ofInit) return;
      el.dataset.ofInit = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
